import { toast } from "sonner";
import request from "../../../helpers/request";
import { IPostConfigPtMonAnalogico } from "./types";

const DTO = (data: IPostConfigPtMonAnalogico) => {
  const {
    idLoja,
    idEquipamento,
    idGrupoMonitor,
    valor,
    escalaInf,
    escalaSup,
    limiteSup,
    limiteInf,
    toleranciaValor,
    toleranciaTime,
    coordX,
    coordY,
    offSet,
    calibracaoEscala,
    hrMsgEscaladaNV2,
    minMsgEscaladaNV2,
    hrMsgEscaladaNV3,
    minMsgEscaladaNV3,
    procedimento,
  } = data;

  const checkDataEscalada = (data) => (!data ? "00" : data);

  return {
    ...data,
    idLoja: Number(idLoja),
    idEquipamento: Number(idEquipamento),
    idGrupoMonitor: Number(idGrupoMonitor),
    valor: Number(valor),
    escalaInf: Number(escalaInf),
    escalaSup: Number(escalaSup),
    limiteSup: Number(limiteSup),
    limiteInf: Number(limiteInf),
    toleranciaValor: Number(toleranciaValor),
    toleranciaTime: Number(toleranciaTime),
    coordX: Number(coordX),
    coordY: Number(coordY),
    offSet: Number(offSet),
    calibracaoEscala: Number(calibracaoEscala),
    timeMsgEscaladaNV2: `${checkDataEscalada(
      hrMsgEscaladaNV2,
    )}:${checkDataEscalada(minMsgEscaladaNV2)}`,
    timeMsgEscaladaNV3: `${checkDataEscalada(
      hrMsgEscaladaNV3,
    )}:${checkDataEscalada(minMsgEscaladaNV3)}`,
    msgFalhaAcimaCustom: "",
    msgFalhaAbaixoCustom: "",
    msgNormalCustom: "",
    procedimento: procedimento || "",
  };
};

export const postConfigPtMonAnalogico = async (
  props: IPostConfigPtMonAnalogico,
) => {
  try {
    const url = `${process.env.REACT_APP_API}/MonAnalogico`;
    const data = DTO({
      ...props,
      valor: 0,
    });

    delete data.hrMsgEscaladaNV2;
    delete data.minMsgEscaladaNV2;
    delete data.hrMsgEscaladaNV3;
    delete data.minMsgEscaladaNV3;

    const result = await request({
      url,
      method: "post",
      data,
      headers: { "Content-Type": "application/json" },
    });

    console.log("result postConfigPtMonAnalogico", result);

    if (result.data.toLowerCase() === "ok") {
      toast.success("Configuração salva com sucesso!");
      return result;
    } else {
      toast.error("Houve um erro ao salvar configuração!");
      throw new Error(result.data);
    }
  } catch (error) {
    toast.error("Houve um erro ao salvar!");
    throw new Error(error as string);
  }
};
